import React, { Component } from "react";
import { MessageBox } from "react-chat-elements";

class FileMessageBox extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { msg, fetchUserFile, dateFormatter } = this.props;

    return (
      <div>
        <MessageBox
          position={msg.owner === "client" ? "left" : "right"}
          text={msg.file_name || "Descargar archivo"}
          title={msg.owner === "client" ? undefined : msg.owner}
          type={"file"}
          onDownload={async () => {
            await fetchUserFile(msg.file_id, msg.id, true);
          }}
          data={{
            uri: msg.file,
            status: { download: msg.file },
          }}
          dateString={dateFormatter(msg.timestamp)}
          className={`message-container ${msg.owner === "nadubot" ? "naduBotText" : msg.owner === "nadunet" ? "nadunetText" : "clientText"}`}
        />
        {msg.content && msg.content.length > 0 && (
          <MessageBox
            position={msg.owner === "client" ? "left" : "right"}
            title={msg.owner === "client" ? undefined : msg.owner}
            type={"text"}
            text={
              msg.content
                ? msg.content.split("\n").map((line, i) => (
                    <span key={i}>
                      {line}
                      <br />
                    </span>
                  ))
                : ""
            }
            dateString={dateFormatter(msg.timestamp)}
            className={`message-container ${msg.owner === "nadubot" ? "naduBotText" : msg.owner === "nadunet" ? "nadunetText" : "clientText"}`}
          />
        )}
      </div>
    );
  }
}

export default FileMessageBox;



// WEBPACK FOOTER //
// ./src/views/NaduChat/components/FileMessageBox.jsx